import React, { useEffect, useState } from 'react'

import { addDaysToDate } from '../../../../utils/dates.ts'
import Button from '../../Button/Button.tsx'
import DatePickerOne from '../../forms/DatePicker/DatePickerOne.tsx'

const PopupDateSelector = ({
  setSelectedDate,
  onCloseClick,
  startDate
}: {
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>
  onCloseClick: () => void
  startDate: Date | undefined
}) => {
  const [selectedPickerDate, setSelectedPickerDate] = useState<Date | null>(
    null
  )
  const minAvailableDateToSend = addDaysToDate(new Date(), 1)
  const maxAvailableDateToSend = addDaysToDate(startDate, -1)

  useEffect(() => {
    setSelectedPickerDate(maxAvailableDateToSend)
  }, [])

  const onClickSetDate = () => {
    setSelectedDate(selectedPickerDate)
    onCloseClick()
  }
  return (
    <div className="min-w-30 flex flex-col justify-center items-center">
      {startDate && (
        <div className="flex flex-col xl:flex-row flex-wrap gap-2 md:px-2 px-8 py-2 mb-6 justify-center items-center w-full bg-blue-400 rounded-md">
          <p className="text-blue-800">
            Pierwszy dzień diety wybrany przez pacjenta:
          </p>
          <p className="text-xl font-bold text-blue-800">{String(startDate)}</p>
        </div>
      )}
      <div className="w-full justify-center">
        <DatePickerOne
          onChange={(e) => setSelectedPickerDate(e[0])}
          minDate={minAvailableDateToSend}
          maxDate={maxAvailableDateToSend}
        />
      </div>
      <div className="w-full flex justify-center mt-8 gap-x-4 px-4">
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="button"
          onClick={onCloseClick}
          className="min-w-[150px] px-4 py-2 bg-red-500 text-white rounded-md shadow-md hover:bg-gray-400 transition-colors"
        >
          Anuluj
        </Button>
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="button"
          onClick={onClickSetDate}
          className="min-w-[150px] px-4 py-2 bg-green-700 text-white rounded-md shadow-md hover:bg-green-600 transition-colors"
          disabled={!selectedPickerDate}
        >
          Zatwierdź
        </Button>
      </div>
    </div>
  )
}

export default PopupDateSelector
